const headerData = [
  {
    prop: "id",
    label: "序号",
    columnwidth: 50,
  },
  {
    prop: "StatusName",
    label: "状态",
    columnwidth: 80,
  },
  {
    prop: "VouCode",
    label: "经销商出库单号",
    columnwidth: 220,
  },
  {
    prop: "InvClassName",
    label: "产品线",
    columnwidth: 160,
  },
  {
    prop: "DPDate",
    label: "出库日期",
    columnwidth: 160,
  },
  {
    prop: "ObjName",
    label: "付款方名称",
    columnwidth: 240,
  },
  {
    prop: 'TerminalHospitalName',
    label: '终端医院名称',
    columnwidth: 200
  },
  {
    prop: "VoucherType",
    label: "单据类型",
    columnwidth: 160,
  },
  {
    prop: "OuterCode",
    label: "外部订单号",
    columnwidth: 160,
  },
  {
    prop: "OuterCode",
    label: "经销商订单号",
    columnwidth: 160,
  },
  {
    prop: "WHName",
    label: "仓库名称",
    columnwidth: 210,
  },
  {
    prop: "Total",
    label: "出库金额",
    columnwidth: 160,
  },
  {
    prop: "Remark",
    label: "备注",
    columnwidth: 160,
  },
  {
    prop: "CreatorName",
    label: "创建人",
    columnwidth: 210,
  },
  {
    prop: "CreateTime",
    label: "创建时间",
    columnwidth: 160,
  },
  {
    prop: "VerifierName",
    label: "审核人",
    columnwidth: 210,
  },
  {
    prop: "VerifyTime",
    label: "审核时间",
    columnwidth: 160,
  },
]
export default headerData
